import find from 'lodash/find';
import isUndefined from 'lodash/isUndefined';

import { getCheckedValue, OptionSwitch } from '@Pages/RetroSynthesis/ProjectParametersDialog/ProjectParametersHelpers';
import { isRPSChecked as isRPSCheckedFn } from '@Pages/RetroSynthesis/ProjectParametersDialog/RPS/mapRCSToRPS';
import { ProjectSynthesisPartner } from '@Pages/RetroSynthesis/constants';
import { getPredictedProcessingTimeIntervalUpdatedValue } from '@Pages/RetroSynthesis/utils';
import { RPS_LIBRARIES } from './constants';

export const USED_BUILDING_BLOCKS = 'RX2_PREDICTION_PLAN_LIBRARIES';

const FULL_SYNTHESIS_PLAN = 'RX2_PREDICTION_PLAN_SHOW_FULL_STEPS';
const SYNTHESIS_PLAN_LENGTH = 'RX2_PREDICTION_PLAN_DEPTH';
const IDENTICAL_REACTIONS_STEPS = 'RX2_PREDICTION_PLAN_STEPS';
const IDENTICAL_BUILDING_BLOCKS = 'RX2_PREDICTION_PLAN_BLOCKS';
const PROCESSING_TIME = 'RX2_PREDICTION_PLAN_PROCESSING_TIME';

export const getBlockArrayValues = (optionName, resp = []) => {
  const optionSet = find(resp, (item) => item && item.name === optionName) || {};
  const values = optionSet?.preferences
    ?.filter((element) => !RPS_LIBRARIES.includes(element.name))
    ?.map((element) => ({
      name: element.name,
      label: element.label,
      values: element.values,
    }));
  return values || [];
};

export const extractSelectedBuildingBlocks = (optionName, resp = []) => {
  const optionSet = find(resp, (item) => item && item.name === optionName) || {};
  const values =
    (optionSet.preferences &&
      optionSet.preferences?.filter((element) => {
        if (!element.values) {
          return false;
        }
        const activeValue =
          element.values?.length === 1
            ? element.values[0]
            : element.values.find((value) => (!isUndefined(value.checked) ? value.checked : value.defaultValue));
        return activeValue && activeValue.value === OptionSwitch.ON;
      })) ||
    [];
  return values.map((element) => element.name) || [];
};

export const extractDefaultPredictedParametersPai = (resp) => {
  const usedBuildingBlocks = extractSelectedBuildingBlocks(USED_BUILDING_BLOCKS, resp);
  return {
    numberOfPlans: getCheckedValue(SYNTHESIS_PLAN_LENGTH, resp),
    identicalReactionsSteps: getCheckedValue(IDENTICAL_REACTIONS_STEPS, resp),
    identicalBuildingBlocks: getCheckedValue(IDENTICAL_BUILDING_BLOCKS, resp),
    fullSynthesisPlan: getCheckedValue(FULL_SYNTHESIS_PLAN, resp) === OptionSwitch.ON,
    processingTime: getPredictedProcessingTimeIntervalUpdatedValue(parseInt(getCheckedValue(PROCESSING_TIME, resp), 10)),
    usedBuildingBlocks,
    isRPSChecked: isRPSCheckedFn(usedBuildingBlocks),
    partner: ProjectSynthesisPartner.PAI,
  };
};
